/* import __COLOCATED_TEMPLATE__ from './font-family-value.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();